/* global $ */
import * as types from './action-types';

export function getStreamUrl(){
  return (dispatch, getState) => {
    const streamUrl = getState().app.player.toJS().stream_url;
    $.ajax({
      method: "GET",
      url: streamUrl,
      async: true,
      error: function(xhr, status, error){
        return console.error(xhr, status, error);
      },
      success: function(data, status, xhr){
        dispatch({
          type: types.UPDATE_CURRENT_STREAM_URL,
          data: data
        });
        dispatch(getCurrentTrackData());
      }
    });
  }
}

export function getCurrentTrackData(){
  return (dispatch, getState) => {
    const nowplayingUrl = getState().app.player.toJS().nowplaying_url;
    $.ajax({
      method: "GET",
      url: nowplayingUrl,
      cache: false,
      async: true,
      error: function(xhr, status, error){
        return console.error(xhr, status, error);
      },
      success: function(data, status, xhr){
        dispatch({
          type: types.UPDATE_CURRENT_TRACK, 
          data: data.data[0]
        });

        let tracks = data.data;
        tracks.splice(0, 1);
        dispatch(updateHistory(tracks));
      }
    });

  };
}

export function updateHistory(data){
  return {
    type: types.UPDATE_HISTORY,
    data: data
  };
}



// WEBPACK FOOTER //
// ./src/actions/remix-actions.js